import {
	createPersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPost,
	getFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGet,
	getUserPersonalityApiV1AuthUserUserIdPersonalityGet,
	patchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatch,
} from "@/shared/api/generated-backend"
import type { PersonalityVisibility } from "../model/types"

export async function getUserPersonality(userId: number) {
	return getUserPersonalityApiV1AuthUserUserIdPersonalityGet({
		path: { user_id: userId },
	})
}

export async function getFriendPersonality(friendId: number) {
	return getFriendPersonalityApiV1AuthFriendsFriendIdPersonalityGet({
		path: { friend_id: friendId },
	})
}

export async function presignPersonalityImage(
	userId: number,
	filename: string,
	contentType: string,
) {
	return createPersonalityImageUploadUrlApiV1AuthUserUserIdPersonalityImagesPresignPost(
		{
			path: { user_id: userId },
			body: { filename, content_type: contentType },
		},
	)
}

export async function patchPersonalityVisibility(
	userId: number,
	visibility: PersonalityVisibility,
) {
	await patchUserPersonalityVisibilityApiV1AuthUserUserIdPersonalityVisibilityPatch(
		{
			path: { user_id: userId },
			body: visibility,
		},
	)
}
